import { useEffect, useState } from "react";
import { describeEmailFlags } from "../../js/api/messaging/emailOutbox";

export default function CloseFileDialog({ transaction, open, busy, onCancel, onConfirm }) {
  const [status, setStatus] = useState("closed");
  const client = transaction?.client;
  const optedIn = Boolean(client?.email_report_opt_in);

  useEffect(() => {
    if (open) setStatus("closed");
  }, [open, transaction?.id]);

  useEffect(() => {
    if (!open) return undefined;
    function onKey(event) {
      if (event.key === "Escape" && !busy) onCancel?.();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, busy, onCancel]);

  if (!open || !transaction) return null;

  const preview = describeEmailFlags({
    broker: { send: true },
    agent: { send: true },
    client: { send: optedIn },
  });

  return (
    <div className="modal-backdrop" role="presentation" onClick={() => !busy && onCancel?.()}>
      <div
        className="modal-container close-file-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="close-file-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-header">
          <h2 id="close-file-title">Close This File</h2>
          <button type="button" className="modal-close" onClick={onCancel} disabled={busy} aria-label="Keep file open">
            ×
          </button>
        </div>
        <div className="modal-body">
          <p>
            A communication report is saved first. Then the file moves to the archive. Nothing is
            deleted.
          </p>
          <fieldset className="choice-fieldset">
            <legend className="field-label">How did this file finish?</legend>
            <div className="choice-group">
              <button
                type="button"
                className={`choice-chip${status === "closed" ? " is-selected" : ""}`}
                onClick={() => setStatus("closed")}
              >
                Complete
              </button>
              <button
                type="button"
                className={`choice-chip${status === "abandoned" ? " is-selected" : ""}`}
                onClick={() => setStatus("abandoned")}
              >
                Did not complete
              </button>
            </div>
          </fieldset>
          <p className="muted">
            {status === "closed"
              ? "Use complete when the search or listing reached a natural close."
              : "Use did not complete when the file is released without a close."}
          </p>
          <p className="muted">{preview}</p>
          {!optedIn ? (
            <p className="field-hint">The client has not asked for a copy, so no client email is queued.</p>
          ) : (
            <p className="field-hint">The client asked for a copy of the communication report.</p>
          )}
          <div className="wizard-actions" style={{ marginTop: "1rem" }}>
            <button type="button" className="ghost-btn" onClick={onCancel} disabled={busy}>
              Keep file open
            </button>
            <button type="button" className="primary-btn" onClick={() => onConfirm(status)} disabled={busy}>
              {busy ? "Archiving…" : "Archive file"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
